/**
 * Category Mega Menu — Custom element for sidebar + content panel interactions.
 *
 * Handles:
 * - Hover on Level 1 sidebar items to show/hide content panels
 * - Active state management
 * - Default first-category selection on open
 */
class CategoryMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.sidebarItems = [];
    this.panels = [];
    this.boundOnSidebarEnter = this.onSidebarItemEnter.bind(this);
    this.boundOnSidebarClick = this.onSidebarItemClick.bind(this);
  }

  connectedCallback() {
    this.sidebarItems = this.querySelectorAll('.category-mega-menu__sidebar-item');
    this.panels = this.querySelectorAll('.category-mega-menu__panel');

    this.sidebarItems.forEach((item) => {
      item.addEventListener('mouseenter', this.boundOnSidebarEnter);
      item.addEventListener('click', this.boundOnSidebarClick);
      item.addEventListener('focus', this.boundOnSidebarEnter);
    });

    // Observe the parent <details> element to reset on open
    const parentDetails = this.closest('details');
    if (parentDetails) {
      parentDetails.addEventListener('toggle', () => {
        if (parentDetails.open) {
          this.activateIndex(0);
        }
      });
    }

    // Set first item active by default
    this.activateIndex(0);
  }

  disconnectedCallback() {
    this.sidebarItems.forEach((item) => {
      item.removeEventListener('mouseenter', this.boundOnSidebarEnter);
      item.removeEventListener('click', this.boundOnSidebarClick);
      item.removeEventListener('focus', this.boundOnSidebarEnter);
    });
  }

  onSidebarItemEnter(event) {
    const index = event.currentTarget.getAttribute('data-category-index');
    if (index !== null) {
      this.activateIndex(parseInt(index, 10));
    }
  }

  onSidebarItemClick(event) {
    // Prevent default only if the item is just a toggle (href="#")
    const href = event.currentTarget.getAttribute('href');
    if (!href || href === '#') {
      event.preventDefault();
    }
    const index = event.currentTarget.getAttribute('data-category-index');
    if (index !== null) {
      this.activateIndex(parseInt(index, 10));
    }
  }

  activateIndex(index) {
    // Update sidebar active states
    this.sidebarItems.forEach((item) => {
      const itemIndex = parseInt(item.getAttribute('data-category-index'), 10);
      item.classList.toggle('is-active', itemIndex === index);
    });

    // Show/hide panels
    this.panels.forEach((panel) => {
      const panelIndex = parseInt(panel.getAttribute('data-category-index'), 10);
      panel.classList.toggle('is-active', panelIndex === index);
    });
  }
}

customElements.define('category-mega-menu', CategoryMegaMenu);
